import styled from 'styled-components'
import { Button } from 'ui/acro'

export const ProgramStart = styled(Button)`
  color: #fff;
  width: 100%;
  max-width: 100%;
  background: #000;
  font-family: 'Proxima-Nova';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.8px;
  color: ${(props) => (props.disabled ? '#fff' : '#fff')};
  background: ${(props) => (props.disabled ? '#000' : '#000')};
  opacity: ${(props) => (props.disabled ? '0.6' : '1')};
  text-transform: uppercase;
  padding: 12px 32px;
  border-radius: 0;

  @media (min-width: 600px) {
    width: 343px;
    margin-top: 24px;
  }
`

export const StartMainContainer = styled.div`
  @media (max-width: 600px) {
    background-color: #fff;
    padding: 8px 13px 53px 13px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
  }
`
